/**
 * Z-Index hierarchy for consistent layering
 * Higher values appear on top
 */
export const Z_INDEX = {
  // Base elements
  BASE: 1,
  
  // Dropdowns, tooltips, popovers
  DROPDOWN: 100,
  TOOLTIP: 200,
  POPOVER: 300,
  
  // Modal and overlay components
  MODAL_OVERLAY: 1000,
  MODAL_CONTENT: 1001,
  
  // Drawer components
  DRAWER_OVERLAY: 2000,
  DRAWER_CONTENT: 2001,
  
  // Toast notifications (should be above modals and drawers)
  TOAST: 9999,
  
  // Critical system notifications (highest priority)
  SYSTEM_ALERT: 10000,
} as const;

export type ZIndexLevel = typeof Z_INDEX[keyof typeof Z_INDEX];
